// 快递包装重量设置
import mainServerClient from "@/services/http/mainServerClient";

export enum CalcType {
    /**按比例计算 */
    PROPORTION = "PROPORTION",
    /**固定重量 */
    FIXED = "FIXED",
}

export interface PackageWeightSetting extends PackageWeightSettingParams {
    id: number;

    companyId: number;
}

// 获取当前用户的包裹重量设置
export function getSetting(): Promise<PackageWeightSetting> {
    return mainServerClient.get(`/packageWeightSetting`);
}

export interface PackageWeightSettingParams {
    calcType: CalcType;

    /**值 */
    value: number;
}

export function add(params: PackageWeightSettingParams) {
    return mainServerClient.post(`/packageWeightSetting`, params);
}

export interface UpdatePackageWeightSettingParams extends PackageWeightSettingParams {
    id: number;
}

// 修改
export function update(params: UpdatePackageWeightSettingParams) {
    const { id } = params;
    return mainServerClient.post(`/packageWeightSetting/update/${id}`, params);
}

export default {
    getSetting,
    add,
    update,
};
